import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const KEY = "ek_active_class";
const EVT = "ek-active-class";

export const getActiveClass = () => localStorage.getItem(KEY) || "";

export function setActiveClass(id) {
  if (id) localStorage.setItem(KEY, id); else localStorage.removeItem(KEY);
  window.dispatchEvent(new Event(EVT));
}

export const pickClass = (list) => {
  const saved = getActiveClass();
  return list.some((c) => c.id === saved) ? saved : list[0]?.id || "";
};

// Classes of the user + active class shared across pages (kept separately per class).
export function useClasses() {
  const [classes, setClasses] = useState([]);
  const [classId, setClassIdState] = useState("");
  useEffect(() => {
    const load = () => api.get("/classes").then(({ data }) => { setClasses(data); setClassIdState(pickClass(data)); }).catch(() => {});
    load();
    window.addEventListener("ek-classes-changed", load);
    return () => window.removeEventListener("ek-classes-changed", load);
  }, []);
  const setClassId = (id) => { setClassIdState(id); setActiveClass(id); };
  return { classes, classId, setClassId };
}

export const notifyClassesChanged = () => window.dispatchEvent(new Event("ek-classes-changed"));
